'use client';

import * as Dialog from '@radix-ui/react-dialog';

import { DialogOverlay } from '@eliadmin/core/src/components/dlz/dialogs/dialog-overlay';
import { REVIEW_COPY } from '@eliadmin/core/src/components/dlz/product-detail/reviews/review-copy';
import { Icon } from '@eliadmin/core/src/components/dlz/ui/icon';
import { Button } from '@eliadmin/core/src/components/ui/button';

export const REVIEW_ADDED_DIALOG = 'REVIEW_ADDED_DIALOG';

/**
 * „Hodnotenie pridané“ (Figma 60152:14768, mobile 60459:106871): replaces the success toast after a
 * review was sent. Opened through the core dialog store by `AddReviewDialog`.
 */
export function ReviewAddedDialog() {
  return (
    <Dialog.Portal>
      <DialogOverlay />
      <Dialog.Content className="fixed left-1/2 top-1/2 z-[200] flex w-[calc(100%-32px)] max-w-[539px] -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-6 rounded-[18px] bg-white px-4 py-6 text-center shadow-[0_8px_24px_-4px_rgba(15,16,18,0.08),0_2px_4px_rgba(15,16,18,0.06)] focus:outline-none data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 motion-reduce:animate-none md:p-6">
        <Icon name="check-circle" size={52} className="text-[#22A04B]" />
        <div className="flex flex-col gap-3">
          <Dialog.Title className="dlz-h2 text-[#0F1012]">{REVIEW_COPY.added.title}</Dialog.Title>
          <Dialog.Description className="dlz-body-m text-[#4F545C]">
            {REVIEW_COPY.added.text}
          </Dialog.Description>
        </div>
        <Dialog.Close asChild>
          <Button className="h-12 w-full md:h-[52px] md:w-auto">{REVIEW_COPY.added.close}</Button>
        </Dialog.Close>
      </Dialog.Content>
    </Dialog.Portal>
  );
}

ReviewAddedDialog.id = REVIEW_ADDED_DIALOG;
